import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../../services/filtering/filter-form-render-service';
import ShipFromActionableFilterPill from '../../../../../components/actionable-filter-pill/connected/shipping/ship-from';
import { SHIP_FROM } from '../../../../../filters/constants';
import messages from './messages';

export default {
  id: SHIP_FROM,
  displayName: <FormattedMessage {...messages.shipFrom} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'ShipFromId',
  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_CHECKLIST, criteriaInformations, existingFiltersHelpers);
  },
  allowsMultipleSelection: true,
  expectsArgumentAsArray: true,
  shouldHideActionButtons: true,
  actionableFilterPill: ShipFromActionableFilterPill,
};
